import { useQuery } from '@tanstack/react-query';

import apiClient from '@/constants/http';
import type { SearchResult, SourceAddress } from '@/types/search';

import type { SearchFilters, UseSearchQueryOptions } from './types';

const fetchSearch = async ({
  publicSearch = true,
  ...filters
}: SearchFilters) => {
  const searchParams = new URLSearchParams();

  if (filters.term) {
    searchParams.append('term', filters.term);
  }

  if (filters.brandId) {
    searchParams.append('filters[brandId]', filters.brandId);
  }

  if (filters.index) {
    searchParams.append('index', filters.index);
  }

  const params = decodeURIComponent(searchParams.toString());

  const { data } = await apiClient.get<SearchResult[]>(
    `/v1/search${publicSearch ? '/public' : ''}?${params}`,
  );

  if (!publicSearch && filters.brandId) {
    return data.filter((item) => item.type !== 'brand');
  }
  return data.filter((item) => item.sourceResult.length > 0);
};

export const useSearchQuery = ({
  filters,
  ...options
}: UseSearchQueryOptions) => {
  const query = useQuery<Exclude<SearchResult, SourceAddress>[]>({
    queryKey: ['search', filters],
    queryFn: () => fetchSearch(filters),
    enabled: filters.term.length > 0,
    ...options,
  });

  return query;
};
